import styled from '@emotion/styled'
import Pagination from '@mui/material/Pagination'
import { theme as newTheme } from 'styles/theme/hav-theme'

export const PaginationContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: fit-content;
  align-items: center;
  gap: ${newTheme.spacing.md} ${newTheme.spacing.sm};

  p {
    margin: 0;
    font-size: ${newTheme.typography.sizes.xs};
  }
`

export const PaginationStyled = styled(Pagination)`
  color: ${newTheme.colors.primary.main};
  font-family: ${newTheme.typography.family.primary};
  font-size: ${newTheme.typography.sizes.sm};
  line-height: normal;
  width: fit-content;

  .MuiPaginationItem-root {
    font-family: ${newTheme.typography.family.primary};
    font-size: ${newTheme.typography.sizes.xs};
    font-weight: ${newTheme.typography.weight.md};
    line-height: normal;
    color: ${newTheme.colors.neutral.black};
    min-height: ${newTheme.spacing.lg};

    &.Mui-selected {
      pointer-events: none;
      color: ${newTheme.colors.neutral.white};
      background-color: ${newTheme.colors.primary.main};
      border: ${newTheme.shapes.borderWidth.thin} ${newTheme.colors.primary.main};
    }

    .MuiPaginationItem-outlinedPrimary {
      color: ${newTheme.colors.tertiary};
      user-select: none;
      pointer-events: none;
    }

    :hover {
      color: ${newTheme.colors.neutral.white};
      background-color: ${newTheme.colors.primary.hover};
    }
  }

  div.MuiPaginationItem-root {
    min-width: ${newTheme.spacing.xm};
    font-size: ${newTheme.typography.sizes.xm};
    font-family: ${newTheme.typography.family.medium};
    color: ${newTheme.colors.primary.main};
    border: none;

    :hover {
      color: ${newTheme.colors.primary.main};
      background-color: transparent;
      border: none;
    }
  }

  @media only screen and (max-width: ${newTheme.breakpoints.md}px) {
    display: flex;
    justify-content: center;
    margin: 0;
  }
`
